export type ImageParams = {
  width?: number;
  height?: number;
  appearanceId?: string; // sticker design
  fontFamilyIds?: string; // font preview
  colors?: string[]; // layer vector renderer
  defaultImageOnError?: boolean; // hot topic
  sameOrigin?: boolean; // design for masking
  viewId?: string; // design draft override
};

export const stringifyImageParams = (params: ImageParams, delimiter: ',' | '&' = ',') => {
  const queryParts: string[] = [];

  for (const [key, value] of Object.entries(params)) {
    if (!value) {
      continue;
    }

    queryParts.push(
      Array.isArray(value)
        ? // special case for color array
          value.map((v, i) => `${key}[${i}]=${encodeURIComponent(v)}`).join(delimiter)
        : `${key}=${encodeURIComponent(value.toString())}`
    );
  }

  return queryParts.length
    ? `${delimiter === '&' ? '?' : delimiter}${queryParts.join(delimiter)}`
    : '';
};
